// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbWrap":"breadcrumbs_breadcrumbWrap__3PEmG"};